module.exports = __webpack_public_path__ + "static/CanelaDeck-Regular-22d22ff09d7781244bb642e6fad028c0.woff";